import React, { CSSProperties } from 'react';
import styles from './search-input.module.scss';
import { SearchSvg } from 'shared/svg';

interface ISearchInputProps {
  value: string;
  placeholder?: string;
  containerStyles?: CSSProperties;
  inputStyles?: CSSProperties;
  onChange: (value: string) => void;
}

export const SearchInput: React.FC<ISearchInputProps> = ({
  value,
  placeholder = 'Поиск',
  containerStyles,
  inputStyles,
  onChange,
}) => {
  return (
    <div className={styles.search_input__container} style={containerStyles}>
      <div className={styles.search_input__icon}>
        <SearchSvg />
      </div>
      <div className={styles.search_input__value}>
        <input
          className={styles.value__input}
          type="text"
          placeholder={placeholder}
          value={value}
          style={inputStyles}
          onChange={(e) => {
            if (onChange) {
              onChange(e.target.value);
            }
          }}
        />
      </div>
    </div>
  );
};
